// @flow

import Notifications from '../constants/Notifications';
import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';

export default class ReviewsFilter extends Component {
  #options: Array<HTMLElement> = [];
  #optionCount: number;
  #handleChange: function;
  #selectName: string;

  /**
   *
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.setUp();

    this.#handleChange = this.handleChange.bind(this);
    this.el.addEventListener(EventNames.CHANGE, this.#handleChange);
  }

  /**
   *
   */
  setUp(): void {
    this.#options = this.el.children;
    this.#optionCount = this.#options.length;
    this.#selectName = this.el.getAttribute('name');

    if (!this.#optionCount) {
      throw new Error('At least one option is required');
    }
    if (!this.#selectName) {
      throw new Error('A name attribute is required');
    }
  }

  /**
   *
   */
  handleChange(): void {
    if (!(this.el instanceof HTMLSelectElement)) return;
    this.notify(Notifications.SORT, {
      type: 'review',
      data: {
        name: this.#selectName,
        value: this.el.value
      },
      reference: this.el.dataset.reference
    });
  }

  /**
   *
   */
  destroy(): void {
    this.el.removeEventListener(EventNames.CLICK, this.#handleChange);
    super.destroy();
  }
}
